import script from "./BlogsPost.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogsPost.vue?vue&type=script&setup=true&lang=js"

import "./BlogsPost.vue?vue&type=style&index=0&id=6155fac2&lang=css"

const __exports__ = script;

export default __exports__